import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { Router } from '@angular/router';
import { ConfigService } from '../../_core/service/config.service';
import { catchError, tap } from 'rxjs/operators';

export interface MaintenanceResponse {
  maintenanceFlag: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private maintenanceSubject = new BehaviorSubject<boolean>(false);
  public maintenance$ = this.maintenanceSubject.asObservable();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private router: Router,
  ) {}

  checkMaintenance(): Observable<MaintenanceResponse> {
    const baseUrl = this.configService.getConfig().requestBaseUrl;
    const maintenanceUrl = `${baseUrl}/maintenance/check`;
    return this.http.get<MaintenanceResponse>(maintenanceUrl).pipe(
      catchError((error) => {
        return of({ maintenanceFlag: false });
      }),
    );
  }

  setMaintenanceMode(isMaintenanceMode: boolean): void {
    this.maintenanceSubject.next(isMaintenanceMode);

    if (isMaintenanceMode && this.router.url !== '/maintenance') {
      this.router.navigate(['/maintenance']);
    }
  }

  isMaintenanceMode(): boolean {
    return this.maintenanceSubject.value;
  }
}
